import { render, staticRenderFns } from "./SurgeryAddPage.vue?vue&type=template&id=4b103cd4&scoped=true&"
import script from "./SurgeryAddPage.vue?vue&type=script&lang=js&"
export * from "./SurgeryAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b103cd4",
  null
  
)

export default component.exports